import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'omni-common-ui';
import is from 'is_js';
import { List, OrderedMap } from 'immutable';
import { actions as Mentor } from 'data/Mentor';
import { actions as GroupMembers } from 'data/GroupMembers';
import { actions as Session } from 'data/SessionPlans';
import { getUnitList } from 'data/Units/accessors';
import CourseViewTable from 'components/CourseViewTable';
import PropTypes from 'prop-types';

const NOT_APPLICABLE = 'N/A';
const LOADING = '…';

const COLUMN_ASSIGNED = 'assigned';
const COLUMN_MASTERED = 'mastered';
const COLUMN_STUDYING = 'studying';

export class MentorTable extends Component {
  componentWillMount() {
    this.props.fetchMentorIfNeeded(this.props.groupId);
  }

  _getHighlightedColumns() {
    const { units, defaultUnitId } = this.props;
    const defaultUnitIndex = units.toList().findIndex((unit) => unit.id === defaultUnitId) * 3;
    if (defaultUnitIndex < 0) {
      return undefined;
    }

    return [defaultUnitIndex, defaultUnitIndex + 1, defaultUnitIndex + 2];
  }

  _renderScore(score) {
    return is.undefined(score) ? NOT_APPLICABLE : score;
  }

  _renderUndefinedScore() {
    return this.props.isLoading ? NOT_APPLICABLE : LOADING;
  }

  _renderCell(member, unit, column) {
    const { groupId, mentor } = this.props;
    const memberMentorInfo = is.not.undefined(mentor) &&
        is.not.undefined(mentor.data) &&
        mentor.data.get(`${groupId}-${unit.id}-${member.studentGeneralInfo.id}`);

    if (! memberMentorInfo) {
      return LOADING;
    }

    switch (column) {
      case COLUMN_ASSIGNED:
        return this._renderScore(memberMentorInfo.wordsAssigned);
      case COLUMN_MASTERED:
        return this._renderScore(memberMentorInfo.wordsMastered);
      case COLUMN_STUDYING:
        return this._renderScore(memberMentorInfo.wordsStudying);
      default:
        throw new Error(`Invalid column ${column}`);
    }
  }

  render() {
    const { units, members } = this.props;
    if (! units) return null;
    return <CourseViewTable students={members} highlightedColumns={this._getHighlightedColumns()}>
      <CourseViewTable.Header>
        <CourseViewTable.Row>
          {
            units.map((unit) => <CourseViewTable.Cell colSpan={3} small>
              {unit.name}
            </CourseViewTable.Cell>)
          }
        </CourseViewTable.Row>
        <CourseViewTable.Row>
          {
            units.map((unit) => [
              <CourseViewTable.Cell columnId={{ unit, column: COLUMN_ASSIGNED }} small>
                Words Assigned
              </CourseViewTable.Cell>,
              <CourseViewTable.Cell columnId={{ unit, column: COLUMN_MASTERED }} small>
                Words Mastered
              </CourseViewTable.Cell>,
              <CourseViewTable.Cell columnId={{ unit, column: COLUMN_STUDYING }} small>
                Words Studying
              </CourseViewTable.Cell>,
            ])
          }
        </CourseViewTable.Row>
      </CourseViewTable.Header>
      <CourseViewTable.Body>
        {(member, { unit, column }) => this._renderCell(member, unit, column)}
      </CourseViewTable.Body>
    </CourseViewTable>;
  }
}

MentorTable.propTypes = {
  defaultUnitId: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  units: PropTypes.instanceOf(OrderedMap).isRequired,
  mentor: PropTypes.shape().isRequired,
  members: PropTypes.instanceOf(List).isRequired,
  fetchMentorIfNeeded: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export function mapStateToProps(state, ownProps) {
  const { groupId } = ownProps.params;
  const members = GroupMembers.getMembersByGroup(state, groupId);
  const defaultSession = Session.getDefaultSession(state, groupId);
  const defaultUnitId = `${defaultSession.unitIds[0]}`;
  const units = getUnitList(state, groupId);
  const mentor = state.get('rootReducer').get('mentor');
  return {
    defaultUnitId,
    groupId,
    units,
    mentor,
    members,
    isLoading: Mentor.isLoading(state, groupId),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Mentor, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MentorTable);



// WEBPACK FOOTER //
// ./containers/Group/Homework/Mentor/component.jsx